<script lang="ts" generics="ITEM extends HierarchicalRecordRow">
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    import type {HierarchicalRecordRow} from 'src/features/record-grid/lib/types';
    import type {Readable} from 'svelte/store';
    import type {Table} from '@tanstack/svelte-table';
    import {createSearchToolbarContext} from 'src/features/search/kp-search-toolbar/search-toolbar.context';
    import SearchToolbarFacets from './SearchToolbarFacets.svelte';
    import SearchToolbarSortings from './SearchToolbarSortings.svelte';
    import SearchToolbarSearchBar from './SearchToolbarSearchBar.svelte';
    import SearchToolbarGridColumnsVisibility from './SearchToolbarGridColumnsVisibility.svelte';
    import KpLoadingInline from 'shared/components/kp-loading/KpLoadingInline.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let table$: Readable<Table<ITEM>> | null = null;
    export let showLoadingIndicator = false;
    export let showFullscreenButton = false;

    export let isFullscreen = false;

    createSearchToolbarContext();
</script>

<div class="kp-search-toolbar">
    <SearchToolbarFacets/>
    <SearchToolbarSortings/>

    {#if table$}
        <SearchToolbarGridColumnsVisibility {table$}/>
    {/if}

    <SearchToolbarSearchBar/>

    {#if showFullscreenButton}
        <KpButton buttonSize="xs" on:click={() => isFullscreen = !isFullscreen}>
            <IconedContent icon={isFullscreen ? 'compress-alt' : 'expand'}>
                {isFullscreen ? 'Zmenšit' : 'Zvětšit'}
            </IconedContent>
        </KpButton>
    {/if}

    {#if showLoadingIndicator}
        <KpLoadingInline size="xxs"/>
    {/if}
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .kp-search-toolbar {
        display: flex;
        flex-wrap: wrap;
        font-size: @font-size-sm;
        padding: 0 @spacing-xs;
        column-gap: @spacing-l;
        row-gap: @spacing-sm;
    }

    :global {
        .kp-search-toolbar {
            .uicon:not(.dropdown-angle-arrow) {
                font-size: @font-size-default;
            }

            .kp-button {
                height: 20px;
                border: none;
                display: flex;
                align-items: center;
                outline-offset: 1px;
                outline: 1px solid @themed-border-muted;
            }
        }
    }
</style>